import {
  wishlistManagementModalActions,
  WishlistManagementModal as WishlistManagementModalComponent,
  WishlistManagementModalState,
  wishlistSnackbarActions,
  WishlistSnackbarType,
} from "halifax";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";
import {
  FAVORITES_ADD_ITEM,
  FAVORITES_CREATE_LIST,
  FAVORITES_EDITED_LIST,
  FAVORITES_VIEWED_MODAL,
  FavoritesEntryProperties,
  FavoritesEntryType,
  FavoritesItemProperties,
  FavoritesListProperties,
} from "redmond";
import { History } from "history";

export interface WishlistManagementModalProps {
  history: History;
  fromDate: Date | null;
  untilDate: Date | null;
  adultsCount: number;
  childrenCount: number[];
  petsCount: number;
  entryType?: FavoritesEntryType;
}

export const WishlistManagementModal = ({
  history,
  fromDate,
  untilDate,
  adultsCount,
  childrenCount,
  petsCount,
  entryType,
}: WishlistManagementModalProps) => {
  const dispatch = useDispatch();

  const { isOpen, listingId, listingImageUrl, stayType } = useSelector(
    (state: { wishlistManagementModal: WishlistManagementModalState }) =>
      state.wishlistManagementModal
  );

  useEffect(() => {
    if (isOpen && entryType) {
      trackEvent({
        eventName: FAVORITES_VIEWED_MODAL,
        properties: {
          entry_type: entryType,
        } as FavoritesEntryProperties,
      });
    }
  }, [isOpen, entryType]);

  const onClose = () => {
    dispatch(wishlistManagementModalActions.closeModal());
  };

  const handleOnCreateWishlist = (wishlistId: string) => {
    trackEvent({
      eventName: FAVORITES_CREATE_LIST,
      properties: {
        favorites_id: wishlistId,
      } as FavoritesListProperties,
    });
  };

  const handleOnDeleteWishlist = (wishlistId: string) => {
    trackEvent({
      eventName: FAVORITES_EDITED_LIST,
      properties: {
        favorites_id: wishlistId,
        action: "delete",
      } as FavoritesListProperties,
    });
  };

  const handleOnAddToWishlist = ({ wishlistId }: { wishlistId: string }) => {
    dispatch(
      wishlistSnackbarActions.showSnackbar({
        type: WishlistSnackbarType.ADD,
        wishlistId: wishlistId,
        listingId: listingId,
        listingImageUrl: listingImageUrl,
      })
    );
    trackEvent({
      eventName: FAVORITES_ADD_ITEM,
      properties: {
        favorites_id: wishlistId,
        item_id: listingId,
        item_type: "vr",
      } as FavoritesItemProperties & FavoritesListProperties,
    });
    onClose();
  };

  return (
    <WishlistManagementModalComponent
      isOpen={isOpen}
      history={history}
      selectedListingId={listingId}
      stayType={stayType}
      onAddToWishlist={handleOnAddToWishlist}
      onCreateWishlist={handleOnCreateWishlist}
      onDeleteWishlist={handleOnDeleteWishlist}
      onViewWishlist={onClose}
      onClose={onClose}
      stayDates={{ fromDate, untilDate }}
      guests={{
        adults: adultsCount,
        children: childrenCount,
        pets: petsCount,
      }}
    />
  );
};
